import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { EastSlider } from '../EastSlider/EastSlider';

@Component
export class ProductGallery extends ThemeComponent {
    @Ref slider!: EastSlider;
    init() {

        // Listen for slide change
        this.listenForSlideChange();
    }

    listenForSlideChange() {
        // Ensure swiper index exists
        if (typeof this.slider.swiper === 'undefined') {
            return;
        }

        // If slide contains a video, hide the zoom button
        // otherwise show it
        this.slider.swiper.on('slideChangeTransitionEnd', (event) => {
            const activeSlide = this.slider.querySelector('.swiper-slide-active');
            const activeSlideVideo = activeSlide?.querySelector('video');

        });
    }
}
